var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "kr_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M-95.8-.4h682.7v512H-95.8z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#kr_svg__a)",
  transform: "translate(89.8 .4)scale(.9375)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-95.8-.4H587v512H-95.8Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-56.3 361.6 -101.3)scale(10.66667)"
}, /*#__PURE__*/React.createElement("g", {
  id: "kr_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  id: "kr_svg__b",
  fill: "#000001",
  d: "M-6-26H6v2H-6Zm0 3H6v2H-6Zm0 3H6v2H-6Z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#kr_svg__b",
  width: "100%",
  height: "100%",
  y: 44
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M0 17v10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cd2e3a",
  d: "M0-12a12 12 0 0 1 0 24Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0047a0",
  d: "M0-12a12 12 0 0 0 0 24A6 6 0 0 0 0 0Z"
}), /*#__PURE__*/React.createElement("circle", {
  cy: -6,
  r: 6,
  fill: "#cd2e3a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-123.7 191.2 62.2)scale(10.66667)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#kr_svg__c",
  width: "100%",
  height: "100%"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M0-23.5v3M0 17v3.5m0 3v3"
})))));
export { SvgKr as ReactComponent };
export default __webpack_public_path__ + "assets/images/kr.cb52920205a3904b12e951c41a680672.svg";